export const USE_MOCK = false;
export const API_BASE = process.env.REACT_APP_API_BASE_URL;
export const SERVER_BASE_URL = process.env.REACT_APP_SERVER_BASE_URL;
export const API_BASE_FILES = process.env.REACT_APP_API_FILES_BASE_URL;
export const PAGE_SIZE = 20;
export const IS_PRODUCTION = process.env.REACT_APP_ENV === 'production';


export const MOCK_DB = {
	chats: ['c1', 'c2'],
	store: {
		c1: {
			messages: [
				{
					role: 'user',
					content: 'سلام! می‌خوام *بولد* و \n\nرفتن به خط بعد رو تست کنم.'
				},
				{
					role: 'assistant',
					content: 'سلام! این یک پاسخ **نمایشی** است. \n\nیک خط جدید هم اینجاست.',
					references: ['آیین‌نامه حیات وحش', 'آینن‌نامه فضای سبز شهری']
				}
			]
		},
		c2: { messages: [] }
	},
	nextId: 3
};

export const mockDelay = (ms = 400) => new Promise((r) => setTimeout(r, ms));